import React, { useEffect, useState, useContext } from "react";
import IconButton from "@mui/material/IconButton";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { PauseCircleOutline } from "@mui/icons-material";
import MyContext from "../../../context/MyContext";
import AuthContext from "../../../context/userAuth.context";
export const GetDur = (props) => {
  const [time, settime] = useState("");
  const { calculateWidthByDuration, CanvasDisplay, onePxEquivalent } =
    useContext(MyContext);
  const { authenticationData } = useContext(AuthContext);

  useEffect(() => {
    let audio = document.createElement("audio");
    audio.src = props.authenticationData.ApiBaseURL + "/" + props.value.path;
    //var audio = document.getElementById('audio-1');
    audio.onloadedmetadata = function () {
      const date = new Date(null);
      date.setSeconds(Math.round(audio.duration)); // specify value for SECONDS here
      const result = date.toISOString().slice(11, 19);
      settime(result + ":000");
      // var totalNumberOfSeconds = Math.round(audio.duration);
      // var hours = parseInt(totalNumberOfSeconds / 3600);
      // var minutes = parseInt((totalNumberOfSeconds - hours * 3600) / 60);
      // var seconds = Math.floor(
      //   totalNumberOfSeconds - (hours * 3600 + minutes * 60).toFixed(0)
      // );
      // var milliseconds = totalNumberOfSeconds / 1000
      // let result =
      //   (minutes < 10 ? "0" + minutes : minutes) +
      //   ":" +
      //   (seconds < 10 ? "0" + seconds : seconds) +
      //   (seconds < 10 ? "0" + seconds : seconds) +
      //   (seconds < 10 ? "0" + seconds : seconds) +
      //   ;
      // // console.log("result =" + result);
      // settime(result);

      // console.log(time);
      // console.log('getting time')
    };
  }, []);

  // const Play =(value, tickerPositionInEffect)=>{
  //   const [audioplay ,setAudioPlay] =useState(false)
  // }
  const calculateWidthByDuration2 = (duration) => {
    //alert("convert into mili seconds");
    var milliseconds = Math.floor((duration % 1000) / 100),
      seconds = Math.floor((duration / 1000) % 60),
      minutes = Math.floor((duration / (1000 * 60)) % 60),
      hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
    hours = hours < 10 ? "0" + hours : hours;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;
    return hours + ":" + minutes + ":" + seconds + "." + milliseconds;
    // var onePxEquivalent = (5000 / 4) / 29
    // var tempArr = duration.split(':');
    // var hours = 0 ;
    // // var hours = parseInt(tempArr[0]);
    // var minutes = parseInt(tempArr[0]);
    // var seconds = parseInt(tempArr[1]);

    // var totalMilliseconds = ((hours * 60 * 60 + minutes * 60 + seconds) * 1000 .toFixed(0));
    // return (Math.round(totalMilliseconds / onePxEquivalent)); //onePxEquivalent
  };
  // play sound

  const calculateTimeByWidth = (width) => {
    let ms = parseFloat(
      (width * localStorage.getItem("onePxEquivalent")).toFixed(3)
    );
    return msToTime(ms);
  };

  const msToTime = (s) => {
    function pad(n, z) {
      z = z || 2;
      return ("00" + n).slice(-z);
    }
    var ms = s % 1000;
    s = (s - ms) / 1000;
    var secs = s % 60;
    s = (s - secs) / 60;
    var mins = s % 60;
    var hrs = (s - mins) / 60;
    return (
      pad(hrs) +
      ":" +
      pad(mins) +
      ":" +
      pad(secs) +
      ":" +
      pad(Math.round(ms), 3)
    );
  };
  // add sounds in  layer
  const AssignSounds = () => {
    let array2 = Array.from(props.LayersData);
    for (let i = 0; i < array2.length; i++) {
      if (array2[i].key == props.values.key) {
        array2[i].TTSDuration = time;
        // A new voice plays whole: forget the trim of the previous one.
        delete array2[i].TTSTrimStart;
        delete array2[i].TTSTrimEnd;
        array2[i].TTSPath = props.value.path;
        array2[i].TTSName = props.value.name;
        array2[i].TTSWidthOnTimeline = calculateWidthByDuration(time);
        array2[i].StartTimeOfTTS = calculateTimeByWidth(array2[i].startPositionOnTimeline);
        array2[i].StartAudioTime = array2[i].startPositionOnTimeline;
        
        // array2[i].StandingJSON=array2[i].JSONValue;
        array2[i].isPlaying = false;
        array2[i].Audio = new Audio(
          authenticationData.ApiBaseURL + "/" + array2[i].TTSPath
        );

        // let sub = array2[i].character_FilePath.split("");
        // sub.splice(46, 11, "T", "a", "l", "k", ".", "j", "s", "o", "n");
        // sub.splice(-2);
        // let joined = sub.join("");
        // fetch(authenticationData.ApiBaseURL + "/" + joined)
        // .then((response) => response.json())
        // .then((json) => {
        //   array2[i].TalkingJSON = json; //talking json added
        // })
        // .catch((e) => {
        //    sub = array2[i].character_FilePath.split("");
        //   sub.splice(46, 11, "T", "a", "l", "k", ".", "j", "s", "o", "n");
        //   sub.splice(-2);

        // });

        //localStorage.setItem("StandingJSON",JSON.stringify(array2[i].JSONValue));

        // const _JSONValue = parseFloat(localStorage.getItem("JSONValue"+array2[i].AnimationId))
        // if(!_JSONValue === null)
        // {
        //   localStorage.setItem("JSONValue"+array2[i].AnimationId, JSON.stringify(array2[i].JSONValue))
        // }
        if (calculateWidthByDuration(time) > array2[i].widthOnTimeline) {
          array2[i].duration = time;
          array2[i].endTime = time;
          array2[i].widthOnTimeline = calculateWidthByDuration(time);
        }

        if (array2[i].text == "" && array2[i].text != array2[i].originalText) {
          array2[i].text = array2[i].originalText;
          array2[i].fontSize = array2[i].originalFontSize;
        } else {
          array2[i].midTransitionWidths = calculateWidthByDuration(time);
          array2[i].midTransitionWidth = calculateWidthByDuration(time);
          // if (time[1] !== "0") {
          //   array2[i].midTransitionWidths = calculateWidthByDuration2(
          //     time[4] + "000"
          //   );
          //   array2[i].completeWithOfTTS = calculateWidthByDuration2(
          //     time[4] + "000"
          //   );

          //   if (
          //     array2[i].widthOnTimeline <
          //     calculateWidthByDuration2(time[4] + "000")
          //   ) {
          //     array2[i].widthOnTimeline = calculateWidthByDuration2(
          //       time[4] + "000"
          //     );
          //   }
          // } else if (parseInt(time.split(":")[1]) > 9) {
          //   const _time = parseInt(time.split(":")[1]);
          //   array2[i].midTransitionWidths = calculateWidthByDuration(
          //     "00:00:00:" + _time + "000"
          //   );
          //   array2[i].completeWithOfTTS = calculateWidthByDuration(
          //     "00:00:00:" + _time + "000"
          //   );

          //   if (
          //     array2[i].widthOnTimeline <
          //     calculateWidthByDuration("00:00:00:" + _time + "000")
          //   )
          //     array2[i].widthOnTimeline = calculateWidthByDuration(
          //       "00:00:00:" + _time + "000"
          //     );
          // } else if (time[1] == "0") {
          //   array2[i].midTransitionWidths = calculateWidthByDuration(
          //     "00:00:00:" + time[4] + "000"
          //   );
          //   array2[i].completeWithOfTTS = calculateWidthByDuration(
          //     "00:00:00:" + time[4] + "000"
          //   );

          //   if (
          //     array2[i].widthOnTimeline <
          //     calculateWidthByDuration("00:00:00:" + time[4] + "000")
          //   )
          //     array2[i].widthOnTimeline = calculateWidthByDuration(
          //       "00:00:00:" + time[4] + "000"
          //     );
          // }
          break;
        }
      }
    }
    props.setLayersData(array2);
    // console.log(array2)
    // console.log('layer data')
  };

  const PlaySound = (value, time) => {
    const _array = Array.from(props.ttsaudios);

    for (let i = 0; i < _array.length; i++) {
      if (value === _array[i]) {
        _array[i].isPlay = false;
        _array[i].Audio = new Audio(
          authenticationData.ApiBaseURL + "/" + value.path
        );
        _array[i].Audio.play();

        const timer = setInterval(() => {
          if (_array[i].Audio.ended) {
            _array[i].isPlay = true;
            clearInterval(timer);

            PlaySound();
          }
        }, 50);
      } else {
        _array[i].isPlay = true;

        if (_array[i].Audio) {
          if (!_array[i].Audio.paused) {
            _array[i].Audio.pause();
          }
        }
      }
    }

    props.setTtsaudios(_array);
  };

  const PauseSound = (value, time) => {
    const _array = Array.from(props.ttsaudios);

    for (let i = 0; i < _array.length; i++) {
      if (value === _array[i]) {
        _array[i].isPlay = true;

        if (_array[i].Audio) {
          if (!_array[i].Audio.paused) {
            _array[i].Audio.pause();
          }
        }
      }
    }

    props.setTtsaudios(_array);
  };

  //
  return (
    <div className="SoundsParentCustom">
      <div className="soundDescription">
        <label className="musicNameBox">{props.value.name}</label>
        <label className="mr-2 smallerLabel" style={{ color: "grey" }}>
          {time}
        </label>
        <label className="smallerLabel">{props.value.createdDate}</label>
      </div>

      <div className="audioButtons">
        {props.value.isPlay ? (
          <button
            onClick={() => PlaySound(props.value, time)}
            class="btn btn-small btn-black"
            style={{ marginRight: "5px" }}
          >
            Listen
          </button>
        ) : (
          <button
            onClick={() => PauseSound(props.value, time)}
            class="btn btn-small btn-yellow"
            style={{ marginRight: "5px" }}
          >
            Pause
          </button>
        )}

        <button
          onClick={() => AssignSounds(props.value)}
          class="btn btn-small btn-blue"
          style={{ marginRight: "5px" }}
        >
          Apply
        </button>
      </div>
    </div>
  );
};

export default GetDur;
